import type { AssessmentSourceStatus } from "@repo/shared";
import type { TranslationTable } from "@repo/shared/types";

/**
 * QL-361 — the product-assessment and quiz-score entries of a "When field"
 * condition picker.
 *
 * The flow picker and the three PDF pickers (component, layout, attachment)
 * all build their `__pa_…` and `__quiz_score_…` entries here, so the list —
 * which modes are offered, how an entry is labelled, which values it takes,
 * which pass score hints at the scale — is defined once. The pickers
 * themselves stay separate.
 */

export const T = {
  en_GB: {
    group: "Product assessment",
    quiz: "Quiz",
    questionnaire: "Questionnaire",
    combined: "Combined",
    simple: "Simple",
    status: "Status",
    score: "Score",
    quizField: "Quiz:",
  },
  nb_NO: {
    group: "Produktvurdering",
    quiz: "Quiz",
    questionnaire: "Spørreskjema",
    combined: "Kombinert",
    simple: "Enkel",
    status: "Status",
    score: "Poengsum",
    quizField: "Quiz:",
  },
} as const;

/** Status value labels — rules always compare the raw status string. */
export const STATUS_T: TranslationTable<Record<AssessmentSourceStatus, string>> = {
  en_GB: {
    passed: "Passed",
    failed: "Not passed",
    unanswered: "Not answered",
    incomplete: "Incomplete",
    true: "Yes",
    false: "No",
  },
  nb_NO: {
    passed: "Bestått",
    failed: "Ikke bestått",
    unanswered: "Ikke besvart",
    incomplete: "Ufullstendig",
    true: "Ja",
    false: "Nei",
  },
};
